import React, { useEffect, useRef, useState } from "react";
import { Box, CircularProgress, Container, Fade } from "@mui/material";
import AppBar from "../components/AppBar";
import PersonManagePage from "./PersonManagePage";
import PersonTableLink from "./PersonTableLink";
import { Navigate, Route, Routes, useNavigate } from "react-router";
import { ViewAllStaff } from "./ViewAllStaff";
import { ManageModal, ManageModalProvider, SlideIn } from "ui";
import AssignPersonLocationPage from "./AssignPersonLocationPage";
import MainMenu from "../components/MainMenu";
import ShiftContainer from "../../components/ShiftContainer";

const PersonManagementRoutes = () => {
  const navigate = useNavigate();

  return (
    <Routes>
      <Route index element={<ViewAllStaff onBack={() => navigate(-1)} />} />
      <Route path="details/:pid" element={(
        <PersonManagePage
          onLink={(id) => navigate(`/manage/users/link/${id}`)}
          onBack={() => navigate(-1)} />
      )} />
      <Route path={"/location/:pid"} element={<AssignPersonLocationPage onBack={() => navigate(-1)} />} />
      <Route path={`link/:pid`} element={<PersonTableLink onBack={() => navigate(-1)} />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  )
}
export const StaffIndexPage = () => {
  const loading = false
  const containerRef = useRef<HTMLDivElement>(null)
  const [containerNode, setContainerNode] = useState<HTMLDivElement | null>(null)
  return (
    <Fade in={true}>
      <Box component="div">
        {/* <SlideInContextProvider> */}
        <ManageModalProvider>
          <div>
            <SlideIn />
            <ManageModal />
            <AppBar />
            <MainMenu />
          </div>
          <ShiftContainer containerRef={containerNode}>
            <Container ref={setContainerNode} maxWidth="xl">
              <Box
                component="div"
                sx={{ paddingTop: "40px", paddingBottom: "32px" }}
              >
                {loading ? (
                  <div
                    style={{
                      width: "100%",
                      height: "50vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress />
                  </div>
                ) : (
                  <PersonManagementRoutes />
                )}
              </Box>
            </Container>
          </ShiftContainer>
        </ManageModalProvider>
        {/* </SlideInContextProvider> */}
      </Box>
    </Fade>
  );
};
